<template>
  <header
    :class="[
      'header',
      { 'header--home': page === 'Home' },
      { active: openMenu },
      { 'header--hidden': !showNavbar },
      { 'header--black': topBlack },
    ]"
  >
    <div class="limit-grid">
      <div class="header__wrapper">
        <div class="header__logo">
          <router-link :to="{ name: 'Home' }">
            <figure v-if="page !== 'Home'">
              <img
                src="@/assets/logo-vermelho.svg"
                alt="logo cartão de todos São Paulo"
              />
            </figure>
            <figure v-else>
              <img
                src="@/assets/logo-branco.svg"
                alt="logo cartão de todos São Paulo"
                v-if="!topBlack"
              />
              <img
                src="@/assets/logo-vermelho.svg"
                alt="logo cartão de todos São Paulo"
                v-else
              />
            </figure>
          </router-link>
        </div>
        <div class="header__mobile-btn" @click.prevent="toggleMenu">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="24"
            viewBox="0 0 32 24"
          >
            <g transform="translate(-322 -22)">
              <rect
                width="32"
                height="4"
                rx="2"
                transform="translate(322 22)"
              />
              <rect
                width="32"
                height="4"
                rx="2"
                transform="translate(322 32)"
              />
              <rect
                width="32"
                height="4"
                rx="2"
                transform="translate(322 42)"
              />
            </g>
          </svg>
        </div>
        <div :class="['header__nav', { active: menu }]">
          <div class="header__nav__close">
            <img
              src="@/assets/icons/close.svg"
              alt="botão fechar"
              @click.prevent="toggleMenu"
            />
          </div>
          <ul class="header__menu">
            <li>
              <router-link :to="{ name: 'Contact' }">Contato</router-link>
            </li>
          </ul>
          <a
            href="https://torcedores.cartaodetodos.com.br/dados-pessoais/?idserv=20"
            target="_blank"
            class="header__button"
            @click="handleCTAClick"
            >Solicite seu Cartão</a
          >
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { handleCTAClick } from "@/services/gtm";

export default {
  data() {
    return {
      page: null,
      lastScrollPosition: 0,
      showNavbar: true,
      openMenu: false,
      topBlack: false,
      menu: false,
    };
  },
  methods: {
    handleCTAClick,
    onScroll() {
      if (window.pageYOffset < 0) {
        return;
      }
      if (Math.abs(window.pageYOffset - this.lastScrollPosition) < 130) {
        return;
      }

      if (window.pageYOffset > 150 && this.$route.name === "Home") {
        this.topBlack = true;
      } else {
        this.topBlack = false;
      }
      this.showNavbar = window.pageYOffset < this.lastScrollPosition;
      this.lastScrollPosition = window.pageYOffset;
    },
    toggleMenu() {
      this.menu = !this.menu;
    },
  },
  mounted() {
    this.lastScrollPosition = window.pageYOffset;
    window.addEventListener("scroll", this.onScroll);
  },
  created() {
    this.page = this.$route.name;
  },
};
</script>

<style lang="scss">
.header {
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0px;
  width: 100%;
  justify-content: center;
  background: $color-white;
  transform: translate3d(0, 0, 0);
  transition: 0.3s ease-in-out;
  padding: 21px 0 10px;
  @include media(">=tablet") {
    &--hidden {
      transform: translate3d(0, -100%, 0);
    }
  }
  &--home {
    background: transparent;
    .header__mobile-btn {
      fill: $color-white;
    }
    .header__menu {
      a {
        color: $color-white;
      }
    }
  }
  &--black {
    background: $color-white;
    .header__menu {
      a {
        color: $color-black;
      }
    }
    .header__mobile-btn {
      fill: $color-black;
    }
  }
  &__wrapper {
    display: grid;
    grid-template-columns: auto max-content;
    align-items: center;
  }
  &__logo {
    img {
      max-width: 175px;
      @include media(">=tablet") {
        max-width: initial;
      }
    }
    // &--cdt {
    //   max-width: 127px;
    //   @include media(">=tablet") {
    //     max-width: initial;
    //   }
    // }
  }
  &__mobile-btn {
    display: block;
    fill: $color-black;
    @include media(">=tablet") {
      fill: $color-white;
      display: none;
    }
  }
  &__nav {
    justify-self: flex-end;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 102;
    background: $color-primary;
    width: calc(100vw - 74px);
    height: 100vh;
    margin-top: 0px;
    transform: translateX(calc(100% + 74px));
    transition: 0.3s ease-in-out;
    @include media(">=tablet") {
      position: initial;
      top: initial;
      right: initial;
      background: initial;
      width: initial;
      height: initial;
      transform: initial;
    }
    &::after {
      content: "";
      width: 74px;
      height: 100vh;
      position: fixed;
      top: 0;
      left: -74px;
      background: RGBA(0, 0, 0, 0.5);
      z-index: -1;
      display: block;
      @include media(">=tablet") {
        display: none;
      }
    }
    &.active {
      transform: translateX(0%);
    }
    &__close {
      text-align: right;
      margin-top: 30px;
      margin-right: 30px;
      display: block;
      @include media(">=tablet") {
        display: none;
      }
    }
  }
  &__menu {
    list-style: none;
    display: block;
    margin: 30% 0px;
    padding: 0px;
    margin-top: 25%;
    margin-bottom: 25%;
    @include media(">=tablet") {
      display: inline-flex;
      justify-content: flex-end;
      margin: 0px;
    }
    li {
      margin-bottom: 30px;
      text-align: center;
      @include media(">=tablet") {
        margin-right: 38px;
        margin-bottom: initial;
        text-align: initial;
      }
      &:last-child {
        margin-right: 0;
      }
    }

    a {
      text-decoration: none;
      font-size: 22px;
      font-weight: bold;
      transition: 0.3s ease-in-out;
      text-transform: uppercase;
      color: $color-white;
      position: relative;
      @include media(">=tablet") {
        color: $color-black;
        font-size: 14px;
        font-weight: normal;
        text-transform: initial;
        &:hover {
          color: $color-primary;
        }
        &.router-link-exact-active {
          &::after {
            content: "";
            display: block;
            width: calc(100% + 15px);
            height: 8px;
            background: $color-primary;
            position: absolute;
            bottom: -15px;
            left: -7.5px;
          }
        }
      }
    }
  }
  &__button {
    display: block;
    max-width: 250px;
    margin: 0px auto;
    padding: 10px 26px;
    border-radius: 31px;
    background: $color-black;
    color: $color-white;
    font-family: "Arvo", serif;
    font-weight: 700;
    font-size: 20px;
    text-decoration: none;
    border: 2px solid transparent;
    transition: 0.3s ease-in-out;
    &:hover {
      background: $color-white;
      color: $color-primary;
      border-color: $color-primary;
    }
    @include media(">=tablet") {
      background: $color-primary;
      display: initial;
      margin: 0px 0px 0px 30px;
    }
  }
}
</style>
